module.exports = __webpack_public_path__ + "assets/pendant-question-ed78aa0a.png";